import { IKeyObjective } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'
import { IGPKeyInitiativeForm } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/gpKeyInitiatives/components/partnerView/components/gpKeyInitiativesEditor/models/gpKeyInitiativeForm'
import { IKeyInitiativeForm } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/lpKeyInitiatives/components/keyInitiativeEditorModal/models/keyInitiativeForm'

export const isKeyObjectiveRelated = (
  keyObjectives: ReadonlyArray<IKeyObjective>,
  target?: IKeyInitiativeForm | IGPKeyInitiativeForm
) => {
  if (!target) {
    return false
  }

  const objective = keyObjectives.find((ko) => ko.key === target.keyObjective)
  if (!objective) {
    return false
  }

  return objective.dataInsight
}
